// src/modules/appointments/pages/AppointmentCreatePage.jsx
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createAppointment, getAppointmentsConfig } from "../api/appointmentsApi";
import { useAuth } from "../../../auth/AuthContext";
import AppointmentForm from "../components/AppointmentForm";

export default function AppointmentCreatePage() {
  const { user } = useAuth();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [config, setConfig] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    getAppointmentsConfig()
      .then(setConfig)
      .catch((e) => console.warn("No se pudo cargar config de citas", e));
  }, []);

  async function handleSubmit(payload) {
    try {
      setSubmitting(true);
      setError("");
      const resourceId = payload.resource_id;
      const appt = await createAppointment({
        ...payload,
        resource_id: undefined,
        resources: resourceId ? [{ resource_id: resourceId, role: "principal" }] : [],
        created_by_user_id: user?.id ?? null,
      });
      navigate(`/appointments/${appt.id}`);
    } catch (e) {
      setError(e.message || "No se pudo crear la cita.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="appointments-module p-4 max-w-4xl mx-auto space-y-4">
      <div className="flex justify-between items-center gap-3 flex-wrap">
        <div>
          <div className="page-title">Nueva cita</div>
          <p className="text-xs text-[color:var(--muted)]">
            Completa los datos del paciente, recurso y horario para registrar la cita.
          </p>
        </div>
      </div>

      <section className="card section">
        {error && (
          <div className="text-xs text-red-600 border border-red-300 rounded p-2 mb-3">
            {error}
          </div>
        )}

        <AppointmentForm
          config={config}
          onSubmit={handleSubmit}
          submitting={submitting}
        />
      </section>
    </div>
  );
}
